const bridge_api = {
  //公司部件库、病害库相关接口
  getCompanyComponentList: '/api/bridge/component/getCompanyComponentList',//公司级：桥梁类型下部位列表
  fillCompanyComponent: '/api/bridge/component/fillCompanyComponent',//公司级：修改部件，比如新增上部结构、下部结构、桥面系的部件
  getCompanyComponentDiseaseByUuid: '/api/bridge/component/getCompanyComponentDiseaseByUuid',//公司级：病害类型
  getCompanyComponentDiseaseByTypeUuid: '/api/bridge/component/getCompanyComponentDiseaseByTypeUuid',//公司级：病害类型下的描述列表
  addCompanyComponentDiseaseType: '/api/bridge/component/addCompanyComponentDiseaseType',//公司级：添加病害类型
  updateCompanyComponentDiseaseType: '/api/bridge/component/updateCompanyComponentDiseaseType',//公司级：编辑病害类型
  delCompanyComponentDiseaseType: '/api/bridge/component/delCompanyComponentDiseaseType',//公司级：删除病害类型
  addCompanyComponentDisease: '/api/bridge/component/addCompanyComponentDisease',//公司级：添加病害下的描述
  updateCompanyComponentDisease: '/api/bridge/component/updateCompanyComponentDisease',//公司级：修改病害下的描述
  delCompanyComponentDisease: '/api/bridge/component/delCompanyComponentDisease',//公司级：删除病害下的描述


  floorPlanRecords: '/api/bridge/floorplan/floorPlanRecords',//根据构件查询病害列表
  saveImg: '/api/bridge/floorplan/save',//保存展位图
  getImg: '/api/bridge/floorplan/getImg',//查询展位图

  getSpecialInspectList: '/api/bridge/detection/specialInspect/getSpecialInspectList',//特殊检测记录列表
  getSpecialInspectDetail: '/api/bridge/detection/specialInspect/getSpecialInspectDetail',//特殊检测记录详情
  getSpecialInspectItemType: '/api/bridge/detection/specialInspect/getSpecialInspectItemType',//查询特殊检测类型
  addSpecialInspect: '/api/bridge/detection/specialInspect/addSpecialInspect',//新增特殊检测
  updateSpecialInspect: '/api/bridge/detection/specialInspect/updateSpecialInspect',//修改特殊检测
  deleteSpecialInspect: '/api/bridge/detection/specialInspect/deleteSpecialInspect',//删除特殊检测

  getDailyInspectItemType: '/api/bridge/detection/dailyInspect/getDailyInspectItemType',//查询检查项目列表
  getDailyInspectDamageType: '/api/bridge/detection/dailyInspect/getDailyInspectDamageType',//查询损坏类型列表
  addDailyInspect: '/api/bridge/detection/dailyInspect/addDailyInspect',//新增巡检记录
  updateDailyInspect: '/api/bridge/detection/dailyInspect/updateDailyInspect',//修改巡检记录
  deleteDailyInspect: '/api/bridge/detection/dailyInspect/deleteDailyInspect',//删除巡检记录
  getDailyInspectList: '/api/bridge/detection/dailyInspect/getDailyInspectList',//巡检记录列表
  getDailyInspectDetail: '/api/bridge/detection/dailyInspect/getDailyInspectDetail',//巡检记录详情
  //查询最新报告
  queryDetectionReport: '/api/bridge/detection/queryDetectionReport',//查询最新报告


  exportPicSn: '/api/bridge/detection/exportPicSn',//外部照片编号导出
  importPicSn: '/api/bridge/detection/importPicSn',//外部照片编号导入






  //桥梁相关
  exportBridges: '/api/bridge/project/exportBridges',//桥梁导出
  importBridges: '/api/bridge/project/importBridges',//桥梁导入

  getProjectList: '/api/bridge/project/getProjectList',//桥梁列表查询
  getTypeList: '/api/bridge/bridgeInfo/getTypeList',//桥梁类型列表查询
  getComponentList: '/api/bridge/component/getComponentList',//桥梁类型下部位列表
  getAllTypeList: '/api/bridge/bridgeInfo/getAllTypeList',//桥梁类型下拉列表
  getDeckPavementList: '/api/bridge/bridgeInfo/getDeckPavementList',//桥梁桥面下拉列表
  getAllDesignLevelList: '/api/bridge/bridgeInfo/getAllDesignLevelList',//桥梁等级下拉列表
  addproject: '/api/bridge/project/addproject',//桥梁新增
  getyCategoryList: '/api/bridge/bridgeInfo/getyCategoryList',//桥梁大类
  getBidgeTypeListByCategory: '/api/bridge/bridgeInfo/getBidgeTypeListByCategory',//桥梁类型
  getProject: '/api/bridge/project/getProject',//桥梁详情
  updateProject: '/api/bridge/project/updateProject',//桥梁编辑
  delProject: '/api/bridge/project/delProject',//桥梁删除

  getDiseasePropertyType: '/api/bridge/disease/getDiseasePropertyType',//获取病害属性类型列表

  getComponentDelAuthority: '/api/bridge/component/getComponentDelAuthority',//根据uuid查看评价部件下是否有构件

  //部件相关
  fillComponent: '/api/bridge/component/fillComponent',//修改部件，比如新增上部结构、下部结构、桥面系的部件

  //成因分析、养护建议相关
  getCompanyReasonAnalysisByUuid: '/api/bridge/component/getCompanyReasonAnalysisByUuid',//公司库-获取病害成因分析根据uuid
  updateCompanyReasonAnalysis: '/api/bridge/component/updateCompanyReasonAnalysis',//公司库-修改病害成因分析根据uuid
  getReasonAnalysisByUuid: '/api/bridge/disease/getReasonAnalysisByUuid',//任务库-基础库-获取病害成因分析根据uuid
  updateReasonAnalysis: '/api/bridge/disease/updateReasonAnalysis',//任务库-基础库-修改病害成因分析根据uuid

  //特殊情况相关
  getDiseaseList: '/api/bridge/projectSpecial/getDiseaseList',//特殊病害列表
  projectSpecialList: '/api/bridge/projectSpecial/projectSpecialList',//特殊情况列表分页
  projectSpecialAdd: '/api/bridge/projectSpecial/add',//新增特殊检测
  projectSpecialUpdate: '/api/bridge/projectSpecial/update',//修改特殊检测
  projectSpecialDelete: '/api/bridge/projectSpecial/delete',//删除特殊检测
  projectSpecialDetail: '/api/bridge/projectSpecial/detail',//特殊检测详情

  //检测记录相关
  inspectionList: '/api/bridge/detection/list',//检测任务记录
  inspectionRecord: '/api/bridge/detection/record',//检测记录详情列表
  inspectionDelete: '/api/bridge/detection/delete',//检测记录删除
  inspectionDetail: '/api/bridge/detection/detail',//检测项详情
  diseaseType: '/api/bridge/disease/type',//病害类型
  diseaseList: '/api/bridge/disease/list',//病害类型下的等级及描述
  updateDisease: '/api/bridge/detection/update',//更新检测内容
  createReport: '/api/bridge/detection/detection',//生成报告
  createReportNew: '/api/bridge/detection/detectionNew',//巡检生成报告(新)
  detectionDailyInspect: '/api/bridge/detection/detectionDailyInspect',//巡检生成报告(新)
  queryAllCmptType: "/api/bridge/detection/queryAllCmptType", //查询所有部件类型接口
  queryMemberByCmptType: "/api/bridge/detection/queryMemberByCmptType",//查询部件类型下构件接口
  detectionAdd: "/api/bridge/detection/add",//新增检测记录
  getyMaintainList: "/api/bridge/bridgeInfo/getyMaintainList",//根据桥梁养护类型

  //用户信息
  uploadUserImage: "/api/admin/user/uploadUserImage",//修改头像
  updateUserPassWord: "/api/admin/user/updateUserPassWord",//修改密码
  //人员上报，角色列表
  getChooseRole: '/api/admin/role/getChooseRole',
  //上传
  mergeComponent: '/icmsapi/sysFile/mergeComponent',
  drawMergeComponent: '/icmsapi/draw/mergeComponent',

  // 获取不同桥梁类型下构件
  getBridgeComponent: '/api/bridge/bridgeInfo/getBridgeComponent',

  // 获取所有桥梁下拉选择
  getAllProject: '/api/bridge/project/getAllProject',
  // 获取公司下人员
  getCompanyUsers: '/api/bridge/projectTask/getCompanyUsers',
  // 获取我的任务列表分页
  getProjectTaskList: '/api/bridge/projectTask/getProjectTaskList',
  // 批量添加任务
  batchAddProjectTask: '/api/bridge/projectTask/batchAddProjectTask',
  // 添加任务
  addProjectTask: '/api/bridge/projectTask/addProjectTask',
  // 复制任务构件
  copyTaskMembers: '/api/bridge/detection/copyTaskMembers',
  // 编辑
  updateProjectTask: '/api/bridge/projectTask/updateProjectTask',
  // 删除
  delProjectTask: '/api/bridge/projectTask/delProjectTask',
  // 发布
  publishedTask: '/api/bridge/projectTask/publishedTask',

  // 获取桥梁构件
  getProjectMemberList: '/api/bridge/projectMember/getProjectMemberList',
  //添加
  addProjectMember: '/api/bridge/projectMember/addProjectMember',
  // 编辑
  updateProjectMember: '/api/bridge/projectMember/updateProjectMember',
  // 构件单个删除
  delProjectMember: '/api/bridge/projectMember/delProjectMember',
  // 构件批量删除
  batchDelProjectMember: '/api/bridge/projectMember/batchDelProjectMember',
  // 获取任务
  getProjectTask: '/api/bridge/projectTask/getProjectTask',

  getProjectMembers: '/api/bridge/projectMember/getProjectMembers',
  //根据桥梁获取最新任务
  getLastProjectTask: '/api/bridge/projectTask/getLastProjectTask',
  //任务批量新增
  batchCopyTask: '/api/bridge/projectTask/batchCopyTask',


  //病害库、部件库
  getComponentDiseaseByUuid: '/api/bridge/disease/getComponentDiseaseByUuid',//病害类型
  addComponentDiseaseType: '/api/bridge/disease/addComponentDiseaseType',//添加病害类型
  updateComponentDiseaseType: '/api/bridge/disease/updateComponentDiseaseType',//编辑病害类型
  delComponentDiseaseType: '/api/bridge/disease/delComponentDiseaseType',//删除病害类型
  getComponentDiseaseByTypeUuid: '/api/bridge/disease/getComponentDiseaseByTypeUuid',//病害类型下的描述列表

  addComponentDisease: '/api/bridge/disease/addComponentDisease',//添加病害下的描述
  updateComponentDisease: '/api/bridge/disease/updateComponentDisease',//修改病害下的描述
  delComponentDisease: '/api/bridge/disease/delComponentDisease',//删除病害下的描述

  //导出数据
  exportDetectionData: "/api/bridge/projectTask/exportDetectionData",


  sectionAdd: "/api/bridge/section/add",//新建接口
  sectionAddBatch: "/api/bridge/section/addBatch",//批量新增
  sectionUpdate: "/api/bridge/section/update",//更新接口
  sectionDelete: "/api/bridge/section/delete",//删除接口

  //项目管理
  subjectList: "/api/bridge/subject/list",//获取项目列表接口
  subjectAdd: "/api/bridge/subject/add",//新建接口
  subjectUpdate: "/api/bridge/subject/update",//更新接口
  subjectDelete: '/api/bridge/subject/delete',//删除项目
  subjectSelect: "/api/bridge/subject/listTree",//获取项目下拉接口
  listBridgeSelect: "/api/bridge/subject/listBridge",//根据项目获取桥梁接口

  mergeBIMInfo: '/api/bridge/bim/mergeBIMInfo',
  uploadImg: '/api/bridge/detection/uploadImg',//检测记录图片上传
  detectionUploadImgBatch: '/api/bridge/detection/uploadImgBatch',//检测记录图片批量上传


  bridgeUploadImg: '/api/bridge/project/uploadImg',//桥梁图片上传
  uploadImgBatch: '/api/bridge/project/uploadImgBatch',//结构照、工作照批量上传


  noteList:'/api/bridge/quicknote/getList',//快捷手记列表
  noteDetail:'/api/bridge/quicknote/getDetail',//快捷手记详情

  getRule:'/api/bridge/projectMember/getRule',//构件批量新增获取规则
  getComponentSub:'/api/bridge/projectMember/getComponentSub',//构件批量新增获取子部件
  batchAddProjectMember:'/api/bridge/projectMember/batchAddProjectMember',//构件批量新增保存


  getDistance:'/api/bridge/disease/getDistance',//检测记录：根据构件位置查询下一级下拉框的数据
  exportDetectionDataUrl:'/api/bridge/projectTask/exportDetectionDataUrl',//检测列表导出

  statistics:'/api/bridge/project/statistics',//检测列表导出
};

export default bridge_api;
